<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <template>
        <UserDataFirmForm
                v-if="item"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserDataFirmForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    UserDataFirmForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    userdatafirmId: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userdatafirm/update/isLoading',
      error: 'userdatafirm/update/error',
      deleteError: 'userdatafirm/del/error',
      deleteLoading: 'userdatafirm/del/isLoading',
      created: 'userdatafirm/create/created',
      deleted: 'userdatafirm/del/deleted',
      retrieved: 'userdatafirm/update/retrieved',
      updated: 'userdatafirm/update/updated',
      violations: 'userdatafirm/update/violations'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.userdatafirmId) {
      this.retrieve(decodeURIComponent(this.userdatafirmId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'userdatafirm/create/reset',
      deleteItem: 'userdatafirm/del/del',
      delReset: 'userdatafirm/del/reset',
      retrieve: 'userdatafirm/update/retrieve',
      updateReset: 'userdatafirm/update/reset',
      update: 'userdatafirm/update/update',
      updateRetrieved: 'userdatafirm/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this userdatafirm ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
